import { post, put } from '.';

export function SendHeartBeat(options = {}) {
    return post<any>(`/app/api/heart_beats`, options);
}

export function StopHeartBeat(id: number) {
    return put<any>(`/app/api/heart_beats/${id}`);
}